import React from 'react';
import './MainSpecifications.css';

const specs = [
  { param: 'Model', value: 'Drive-In Premium' },
  { param: 'Total Power', value: '35 KVA' },
  { param: 'Power Supply', value: '415V / 22kW / 50Hz–60Hz' },
  { param: 'Installation Dimensions (L×W×H)', value: '7000 × 4300 × 3200 mm' },
  { param: 'Maximum Vehicle Size (L×W×H)', value: '5400 × 2600 × 2050 mm' },
  { param: 'Rail Length', value: '7000 mm' },
  { param: 'Total Weight / Volume', value: '2200 kg / 12 m³' },
  { param: 'CPU System', value: 'Embedded Industrial Control CPU' },
  { param: 'Drive Systems', value: 'Longitudinal / Transverse / Rotary – Frequency Converter Controlled' },
  { param: 'Vehicle Detection System', value: 'Ultrasonic + Encoder Ranging' },
  { param: 'Chemical Mixing System', value: 'Automatic Metering Pump with Precision Ratio Control' },
  { param: 'Collision Safety System', value: 'Digital Electronic Collision Avoidance' },
  { param: 'Blower System', value: 'Side Blower Movement for Enhanced Drying' },
  { param: 'Rotary Arm', value: '304 Stainless Steel, 360° Rotation, Up/Down Ectopic Flushing' },
  { param: 'Main Pump Motor Power', value: '15 kW' },
  { param: 'Drying Motor Power', value: '6 × 5 HP Moveable Dryers (Top & Side)' },
  { param: 'Chemical Spray Pump', value: '304 Stainless Steel' },
  { param: 'Flushing Pressure', value: '100 kg' },
  { param: 'Flush Cycle Time', value: '50 seconds' },
  { param: 'Car Wash Time', value: 'Approx. 6 min (Standard) / 10 min (Fine Wash)' },
  { param: 'Chemical Consumption', value: '20–50 ml per car (via Metering Pump)' },
  { param: 'Power Consumption per Car', value: '0.3 – 0.8 kWh' },
  { param: 'Water Consumption per Car', value: '90 – 160 liters' },
  { param: 'Sheet Metal Processing', value: 'Automotive-Grade Electrophoretic Coating' },
  { param: 'Self-Parking System', value: 'Included' },
  { param: 'Chassis & Wheel Wash', value: 'Integrated' },
  { param: 'LED Guidance System', value: 'Included' },
  { param: 'Install Frame', value: 'Hot-Dip Galvanized' },
];

const MainSpecifications = () => (
  <section className="main-specs-section container">
 <h2 className="main-specs-title">
 Full Car Cleaning Machine Service Near Me
</h2>
<div className="main-specs-subtitle">
  Drive-In Premium Automatic Car Wash System
</div>
    <div className="main-specs-table-wrapper">
      <table className="main-specs-table">
        <thead>
          <tr>
            <th>Parameter</th>
            <th>Specification</th>
          </tr>
        </thead>
        <tbody>
          {specs.map((row, idx) => (
            <tr key={row.param} className={idx % 2 === 0 ? 'even' : 'odd'}>
              <td>{row.param}</td>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

export default MainSpecifications; 